export default [
  {
    name: 'gdspo-sim-card-edit',
    path: '/gdspo/sim-cards/:id/edit',
    component: () => import('@/views/sim-cards/gdspo/GDSPOSimCardManage')
  },
  {
    name: 'gdspo-sim-card-view',
    path: '/gdspo/sim-cards/:id/view',
    component: () => import('@/views/sim-cards/gdspo/GDSPOSimCardManage')
  },
  {
    name: 'gdspo-sim-card-find',
    path: '/gdspo/sim-cards/find',
    component: () => import('@/views/sim-cards/gdspo/GDSPOSimCardFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeGDSPOSimCards.js